<template>
  <div class="merchant-user">
    <div class="content">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label>用户名:</label>
            <input v-model="search.name" class="form-control" type="text" placeholder size="12" v-noBlankSpace />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
               @click="searchList" 
               type="button" 
               class="btn btn-primary"
                id="search_btn"
                :loading="loading"
                size="small"
                >
                查询
              </el-button>
            </span>
            <span class="add_btn">
              <button type="button" class="btn btn-default" @click="addrOrEdit()">
                添加
              </button>
            </span>
          </div>
        </form>
      </div>

      <el-table 
      border
       height="100%" 
       :data="tableListData" 
       :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
        >
        <el-table-column show-overflow-tooltip label="用户名" prop="name"></el-table-column>

        <el-table-column show-overflow-tooltip label="电话" prop="mobile"></el-table-column>

        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button class="edit operate-button" type="button" @click="addrOrEdit(scope.row)">
              修改
            </button>
            <button class="delete operate-button" type="button" @click="del(scope.row.adminId)">
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Page v-on:pagination="receivePaginationData"></Page>
    <merchant-user-update :merchantUserVisible="merchantUserVisible" :merchant="merchant" :merchantUser="merchantUser"></merchant-user-update>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {

  updateMerchantUser,
  groupMerchantUser,
  resetPassword,
} from "@/api/url";

import Page from "../../../../../commons/parking/commons/page.vue";

import MerchantUserUpdate from "../MerchantUserUpdate/MerchantUserUpdate.vue";

export default {
  props: {
    merchant: Object
  },
  // inject:['merchant'],
  data() {
    return {
      moduleName: "property",
      merchantUserVisible: false,

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
        // carType:"",
        // plateType:"",
        // openMethod:"",
        // beginDate:'',
        // endDate:''
      },

      tableListData: [],
    

      formLabelWidth: "100px",

    merchantUser:null,
    loading: false,
    };
  },
  components: {
    Page,

    MerchantUserUpdate,
  },
 
  watch: {
    merchant: {
      handler(newVal, oldVal) {
   
        this.tableList(1);
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },

  mounted: function () { this.tableList(1);},
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.merchant?.id) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {//待定
      var _this = this;
      this.loading = true;
      this.$get(groupMerchantUser(), {
        shopsId: this.merchant?.id,
        name: this.search.name,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      }).finally(() => {
        this.loading = false;
      });
    },
    searchList: function () {
      if (!this.merchant?.id) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    addrOrEdit(row) {
     
      this.merchantUser=row??null;
      this.merchantUserVisible = true;
    },

    // del(id) {
    //   this.$deleteRequest(addShopUser() + "/" + id).then(data => {
    //     if (data.status != 200) return;
    //     this.$notify({
    //       type: "success",
    //       title: "成功",
    //       message: "删除成功！"
    //     });
    //     this.tableList(this.curIndex);
    //   });
    // },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$deleteRequest(updateMerchantUser() + "/" + id )
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    },
    // 重置密码
    resetPassword: function (password, id) {
      var _this = this;
      this.$putRequest(resetPassword(), {
        id: this.formData.mchid,
        password: this.formData.password,
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          title: "成功",
          message: "重置密码成功,默认密码是0123456",
          type: "success",
        });
      });
    },

    // 修改密码
    //   resetPassword(id,name, password) {
    //   this.dialogResetVisible = true;
    //   this.resetFormData.id = id;
    //   this.resetFormData.name = name;
    //   // this.resetFormData.password = password
    //   this.resetFormData.newPassword = "";
    // },
    // resetTrue() {
    //   this.dialogResetVisible = false;
    //   this.$postRequest(resetPasswordV(), {
    //     id: this.resetFormData.id,
    //     password: this.resetFormData.newPassword
    //   }).then(data => {
    //     if (data.status != 200) return;
    //     this.$notify({
    //       type: "success",
    //       title: "成功",
    //       message: "修改成功！"
    //     });
    //     this.tableList(this.curIndex);
    //   });
    // },
    // 充值

    merchantUserUpdateCallback() {
      this.merchantUserVisible = false;
      this.tableList(this.pageObj.curIndex);
    },
  },
};
</script>

<style scoped>
.sameLine .el-form-item__content .el-input {
  display: inline-block;
  width: 70%;
}

.tip {
  color: red;
}
</style>
<style lang="scss">
.merchant-user {
  width: 100%;
  height: 100%;

  .content {
    width: 100%;
    height: 100%;
  }
}
</style>
